import { Field, useForm, useFormState } from 'react-final-form';
import styled from 'styled-components';
import { FormTextField } from 'components';
import { Button, MenuItem } from '@material-ui/core';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 12px;
  min-width: 320px;
`;

type Props = {
  onNewAdditionalFilter?: () => void;
};

export const RenderSellerForm = (_props: Props) => {
  const form = useForm();
  const formState = useFormState();

  const hasValues = formState.values && Object.keys(formState.values).length > 0;

  return (
    <Wrapper>
      <Field component={FormTextField as any} name="status" label="Filter by Car Status" select>
        <MenuItem value="">All</MenuItem>
        <MenuItem value="active">Active</MenuItem>
        <MenuItem value="awarded">Awarded</MenuItem>
        <MenuItem value="draft">Draft</MenuItem>
        <MenuItem value="pulled">Pulled</MenuItem>
        <MenuItem value="deactivated">Deactivated</MenuItem>
      </Field>
      {hasValues && (
        <Button style={{ marginTop: '18px' }} onClick={() => form.reset({})} variant="contained" color="primary">
          Reset
        </Button>
      )}
    </Wrapper>
  );
};
